export enum VideoObservation {
    Collision,
    Witness,
    Turning,
    Braking,
    Acceleration,
    Stationary,
    Reversing,
    Pedestrians,
    Awareness,
    Impatience,
    Perception,
    Preventable,
    NonPreventable,
    ReactionTime,
    Speeding,
    FollowingDistance 
}
